import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/* Slim banner for patchy mobile networks: tells the customer why actions are not going through. */
export default function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  useEffect(() => {
    const up = () => setOnline(true), down = () => setOnline(false);
    window.addEventListener("online", up); window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  if (online) return null;
  return (
    <div role="status" data-testid="offline-banner" className="fixed inset-x-0 top-0 z-[90] flex items-center justify-center gap-2 bg-amber-500 px-3 py-1.5 text-xs font-semibold text-black" style={{ paddingTop: "max(.375rem, env(safe-area-inset-top))" }}>
      <WifiOff className="h-3.5 w-3.5" /> You are offline. Changes will work again when you reconnect.
    </div>
  );
}
